<template>
  <div>
    <div class="d-flex flex-row justify-content-between align-items-center">
      <div class="py-2">
        <router-link :to="'/service/' + service.id">
          <h4>{{ service.name }}</h4>
        </router-link>
      </div>
      <div>
        <Button
          type="outline"
          :label="isInCart ? 'Remove' : 'Add'"
          size="sm"
          @click="toggleSelection"
        />
      </div>
    </div>
    <CollapseComponent>
      <ViewGenerator :viewmodel="serviceViewmodel" />
    </CollapseComponent>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { IBiobanks, IServices } from "../../interfaces/directory";
import { getServiceProvider } from "../../functions/dataModel";
import { getServiceViewmodel } from "../../functions/serviceViewmodel";
import { useSettingsStore } from "../../stores/settingsStore";
import { useCheckoutStore } from "../../stores/checkoutStore";
import ViewGenerator from "../generators/ViewGenerator.vue";
import Button from "../Button.vue";
import CollapseComponent from "../report-components/CollapseComponent.vue";

const props = defineProps<{
  service: IServices;
}>();

const settingsStore = useSettingsStore();

/** Same config as the service report page, so the two views cannot drift. */
const serviceViewmodel = computed(() =>
  getServiceViewmodel(props.service, settingsStore.config.serviceReportColumns)
);

const isInCart = computed(() =>
  useCheckoutStore().isInCart(props.service.id ?? "")
);

function toggleSelection() {
  const bookmark = false;
  const serviceProvider = getServiceProvider(props.service);

  if (isInCart.value) {
    useCheckoutStore().removeServicesFromSelection(
      { name: serviceProvider.name },
      [props.service.id],
      bookmark
    );
  } else {
    useCheckoutStore().addServicesToSelection(
      {
        id: serviceProvider.id,
        name: serviceProvider.name,
      } as IBiobanks,
      [{ label: props.service.name, value: props.service.id }],
      bookmark
    );
  }
}
</script>
